import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  gap: 8px;
`;

export const Title = styled.h3`
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  color: ${({ theme }) => theme.colors.text};
  text-align: center;
  font-feature-settings: 'liga' off, 'clig' off;
  margin: 0;
`;

export const Description = styled.p`
  color: ${({ theme }) => theme.colors.text};
  text-align: center;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  margin: 0;
`; 